import React, {useState, useEffect} from "react";
import { Link} from "react-router-dom";
import { faCreditCard, faHome, faLocationDot, faBriefcase, faPlus, faFile, faAddressCard, faPager} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HeaderSiderItem from "./HeaderSiderItem";
import "./header.css"
import { faMedapps } from "@fortawesome/free-brands-svg-icons";
import { faRectangleList } from "@fortawesome/free-regular-svg-icons";

const HeaderSider = () => {

    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);
    const [session, setSession] = useState({});
    const [login, setLogin] = useState(false);

    const isMobile = width <= 768;

    useEffect(()=>{
        window.scrollTo(0, 0);
        const sessionStored = localStorage.getItem("session");
        if(sessionStored){
            setSession(sessionStored);
            setLogin(true);
        }
    }, [])

    const styles = {
        bar: {
            width:220,
            height: height,
        }
    }
    
    const navs = [
        {type:"link", url: "/", icon:faHome, name:"Home"},
        {type:"space"},
        {type:"label", name: "LEARNING CONTENTS"},
        {type:"link", url: "/topic/new", icon:faPlus, name:"Create New Topic"},
        {type:"link", url: "/topics/me", icon:faRectangleList, name:"Topics"},

        {type:"space"},
        {type:"label", name: "JOB"},
        {type:"link", url: "/job/new", icon:faPlus, name:"Post New Job"},
        {type:"link", url: "/jobs/me", icon:faBriefcase, name:"Posted Jobs"},
        {type:"link", url: "/cv/me", icon:faAddressCard, name:"My CV"},

        {type:"space"},
        {type:"label", name: "CAREER PAGE"},
        {type:"link", url: "/topic/new", icon:faPlus, name:"New Career Page"},
        {type:"link", url: "#", icon:faPager, name:"Pages"},

        {type:"space"},
        {type:"label", name: "WORK TOOLS"},
        {type:"link", url: "/payment/plans", icon:faCreditCard, name:"CV Scan"},

        {type:"space"},
        {type:"label", name: "OTHERS"},
        {type:"link", url: "/payment/plans", icon:faCreditCard, name:"Pricing"},
        {type:"link", url: "/contact?type=lead&item=", icon:faLocationDot, name:"Contact"},
    ]
    
    return (
        <nav style={styles.bar} className="side-bar">
            <ul>
                {navs.map((itm, index)=>(
                    (itm != null) && <HeaderSiderItem key={index} obj={itm} />
                ))}
            </ul>
        </nav>
    )

};

export default HeaderSider;